import { Field, ObjectType, ID, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('InventoryLocationInput')
export class InventoryLocation {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: 'DEFAULT_LOCATION' })
  _id: string
}
